export default {
  groupTodo: '业务待办',
  groupProject: '项目管理',
  groupAssets: '数据资产',
  groupPlatform: '平台管理',
  groupSysAdmin: '系统管理',
  groupFinance: '交易与财务',
  groupAdmin: '管理员',
  groupSuperAdmin: '超级管理员',
  bizStats: '业务数据统计',
  todoTasks: '事项待办',
  photoLive: '照片直播',
  cloudSpace: '半度云空间',
  conference: '会务系统',
  eventManage: '活动管理',
  registrationManage: '问卷管理',
  venueManage: '座位场地管理',
  hotelManage: '酒店配置',
  receptionManage: '接待管理',
  donationManage: '捐款管理',
  cardManage: '名片管理',
  memberManage: '会员管理',
  memberPlan: '会员套餐',
  referralConfig: '推荐配置',
  accountManage: '账号管理',
  roleManage: '角色管理',
  permissionManage: '权限管理',
  companyManage: '公司管理',
  resourceGrantManage: '资源授权',
  attendeeManage: '参会者管理',
  staffManage: '工作人员管理',
  orderRecords: '订单记录',
  assetManage: '资产管理',
  refundManage: '退款管理'
}
